import { computed } from 'vue';

export default function useKillswitches() {
  const navKillswitch = useNavKillswitch();
  return computed(() => navKillswitch?.killswitches);
}
